import axios from 'axios';

let config = require('@/utils/config.js');

 let base=config.API_URL;//本地代理
// let base='http://api.yjt5679.com';
console.log(process.env)
export const baseApi = base;

//登录获取token
export const login = params => {
    return axios.post(`${base}/agent/login`, params).then(res => res.data);
};
//校验邀请码
export const tobeCheck = params => {
    return axios.post(`${base}/user/tobe/check?randCode=`+params.randCode, params).then(res => res.data);
};

//获取代理基础数据
export const myInfo = params => {
    return axios.get(`${base}/agent/data`, params).then(res => res.data);
};
//获取个人中心数据
export const myCentre = params => {
    return axios.get(`${base}/agent/data`, params).then(res => res.data);
};
//获取个人中心数据
export const getAgentUserInfo = params => {
    return axios.get(`${base}/agent/data`, params).then(res => res.data);
};

//获取我的通讯录
export const childrenList = params => {
    console.log(params)
    return axios.get(`${base}/agent/invite-list`,   {  params:params}).then(res => res.data);
};
//代理注册
export const register = params => {
    return axios.post(`${base}/agent/register `, params).then(res => res.data);
};
//发送验证码
export const yzm = params => {
    return axios.post(`${base}/sms/yzm`, params).then(res => res.data);
};
//忘记密码
export const passwordUpdate = params => {
    return axios.post(`${base}/sys/user/pwd-set`, params).then(res => res.data);
};
//修改密码
export const pwdUpdate = params => {
    return axios.post(`${base}/sys/user/pwd/update`, params).then(res => res.data);
};
//获取最新邀请码
export const tobeInfo = params => {
    return axios.post(`${base}/agent-tobe/generate`, params).then(res => res.data);
};

//获取等级明细
export const levelList = params => {
    return axios.get(`${base}/agent-level/my-list`, params).then(res => res.data);
};
//升级详情
export const levelUp = params => {
    return axios.get(`${base}/agent-level/up-check`, {  params:params}).then(res => res.data);
};
//获取邀请码数据
export const tobeList = params => {
    return axios.get(`${base}/yy/tobe/list`, params).then(res => res.data);
};
//发起升级
export const levelUpApply = params => {
    return axios.post(`${base}/agent-level/apply`, params).then(res => res.data);
};

//降级详情
export const levelDown = params => {
    return axios.get(`${base}/user/level/down/check`, {  params:params}).then(res => res.data);
};

//发起降级
export const levelDownApply = params => {
    return axios.post(`${base}/user/level/down/apply`, params).then(res => res.data);
};
//取消升降级
export const levelDownCancel = params => {
    return axios.post(`${base}/user/level/cancel`, params).then(res => res.data);
};
//查询消息中心
export const msgList = params => {
    return axios.get(`${base}/opesg/list`,  {  params:params}).then(res => res.data);
};
//查询退出记录
export const quitInfo = params => {
    return axios.get(`${base}/user/quit/info`,  {  params:params}).then(res => res.data);
};

//查询退出记录
export const quitApply = params => {
    return axios.post(`${base}/user/quit/apply`,   params).then(res => res.data);
};
//我的直销
export const inviteList = params => {
    console.log(params)
    return axios.get(`${base}/agent/invite/list`,  {  params:params}).then(res => res.data);
};
//退出审核批准
export const quitAudit = params => {
    return axios.post(`${base}/user/quit/audit`,   params).then(res => res.data);
};

//修改个人信息
export const improveInfo = params => {
    return axios.post(`${base}//agent/improve-info`, params).then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/api/login.js